import ENGLISH from "./translations/en.json";
import POLISH from "./translations/pl.json";

export const LOCALES = {
  ENGLISH: "en",
  POLISH: "pl",
};

export const localeMessages = {
  [LOCALES.ENGLISH]: ENGLISH,
  [LOCALES.POLISH]: POLISH,
};
